import axiosClient from './axiosClient';

const authService = {
    login: async (credentials) => {
        const response = await axiosClient.post('/login', credentials);
        // Save token & user info locally.

        if (response.data?.token) {
            localStorage.setItem('token', response.data.token);
            
            // Enrich userInfo with accountType so SocketContext correctly registers the vendor_notification listener
            const enrichedUser = {
                ...response.data.user,
                accountType: response.data.user?.accountType || response.data.user?.role
            };
            localStorage.setItem('userInfo', JSON.stringify(enrichedUser));

            if (response.data.vendor) {
                localStorage.setItem('vendorInfo', JSON.stringify(response.data.vendor));
            }
            if (response.data.rider) {
                localStorage.setItem('riderInfo', JSON.stringify(response.data.rider));
            }
        }
        return response.data;
    },

    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('vendorInfo');
        localStorage.removeItem('riderInfo');
    },
    registerEmail: async (email) => {
        const response = await axiosClient.post('/email-verify', { email });
        localStorage.setItem('reg_token', response.data.token);
        return response.data;
    },

    verifyRegistrationOtp: async (token, code) => {
        const response = await axiosClient.post('/verify-otp', { token, otp: code, purpose: 'email-verify' });
        localStorage.setItem('reg_token', response.data.token);
        return response.data;
    },

    completeProfile: async (profileData, token) => {
        const data = { ...profileData, token };
        const response = await axiosClient.post('/vendor/signup', data);
        localStorage.setItem('reg_token', response.data.token);
        return response.data;
    },

    updateBankDetails: async (payload) => {
        const response = await axiosClient.put('/vendor/bank', payload);
        return response.data;
    },

    forgotPassword: async (email) => {
        const response = await axiosClient.post('/forgot-password', { email });
        return response.data;
    },

    verifyForgotPasswordOtp: async (token, otp) => {
        const payload = {
            token,
            otp,
            purpose: 'forgot-password'
        };
        const response = await axiosClient.post('/verify-otp', payload);
        return response.data; //
    },

    resetPassword: async (token, password) => {
        const payload = {
            token,
            password
        };
        const response = await axiosClient.put('/reset-password', payload);
        return response.data;
    },

    checkVendorStatus: async () => {
        const response = await axiosClient.get('/vendor');
        if (response.data?.data?.vendor) {
            localStorage.setItem('vendorInfo', JSON.stringify(response.data.data.vendor));
        }
        return response.data.data;
    }
};

export default authService;
